import { z } from 'zod/v4'

/** Error codes of the content management API (#4060) and the HTTP status each one travels with. */
export const CONTENT_ERROR_CODES = [
  'CONTENT_TYPE_UNKNOWN',
  'CONTENT_ELEMENT_NOT_FOUND',
  'CONTENT_REASON_REQUIRED',
  'CONTENT_BASE_OUTDATED',
  'CONTENT_PUBLISH_REJECTED',
  'CONTENT_WRITE_WHILE_IMPERSONATING',
] as const
export type ContentErrorCode = (typeof CONTENT_ERROR_CODES)[number]

export const CONTENT_ERROR_STATUS: Readonly<Record<ContentErrorCode, 400 | 403 | 404 | 409>> = {
  CONTENT_TYPE_UNKNOWN: 404,
  CONTENT_ELEMENT_NOT_FOUND: 404,
  CONTENT_REASON_REQUIRED: 400,
  CONTENT_BASE_OUTDATED: 409,
  CONTENT_PUBLISH_REJECTED: 409,
  CONTENT_WRITE_WHILE_IMPERSONATING: 403,
}

/** `current: null` means the element was retired while the person was editing. */
export const contentBaseOutdatedDetailsSchema = z.strictObject({
  current: z
    .strictObject({ versionId: z.guid(), versionNo: z.number().int().positive() })
    .nullable(),
})
export type ContentBaseOutdatedDetails = z.infer<typeof contentBaseOutdatedDetailsSchema>

export const contentPublishRejectedDetailsSchema = z
  .array(z.strictObject({ code: z.string().min(1), field: z.string().nullable() }))
  .min(1)
export type ContentPublishRejectedDetails = z.infer<typeof contentPublishRejectedDetailsSchema>
